import Service, {
  ServiceCreator,
  ServiceDeleter,
  ServiceReader,
  ServiceUpdater,
} from "../../..";
import TransmedRegistrationFieldsApi from "../../../../api/transmed/registration/fields";
import TransmedValidateRegistrationFieldApi from "../../../../api/transmed/validation/field";
import TransmedRegistrationField, {
  TransmedRegistrationFieldInput,
} from "../../../../dtos/transmed/process/registration/field";
import { TransmedRegistrationFieldsInput } from "../../../../dtos/transmed/process/registration/registration";
import {
  TransmedRegistrationFieldValidationCreateInput,
  TransmedRegistrationFieldValidationInput,
} from "../../../../dtos/transmed/process/validation/field";

class TransmedRegistrationFieldServiceReader extends ServiceReader {}

class TransmedRegistrationFieldServiceCreator extends ServiceCreator {
  public async registrationField(
    fieldId: number,
    registrationId: number
  ): Promise<TransmedRegistrationField> {
    return await new TransmedValidateRegistrationFieldApi().post(
      new TransmedRegistrationFieldValidationCreateInput(
        fieldId,
        registrationId
      )
    );
  }

  public async fileSave(
    files: { id: number; quantity: number; file: File | null }[]
  ): Promise<void> {
    return await new TransmedRegistrationFieldsApi().post(
      new TransmedRegistrationFieldsInput(
        files.map(
          (entry) =>
            new TransmedRegistrationFieldInput(
              entry.id,
              entry.quantity,
              entry.file
            )
        )
      )
    );
  }
}
class TransmedRegistrationFieldServiceUpdater extends ServiceUpdater {
  public async validate(
    id: number,
    quantity: number,
    answer: string | null
  ): Promise<TransmedRegistrationField> {
    return await new TransmedValidateRegistrationFieldApi().put(
      `${id}`,
      new TransmedRegistrationFieldValidationInput(quantity, answer, true)
    );
  }

  public async invalidate(
    id: number,
    quantity: number,
    answer: string | null
  ): Promise<TransmedRegistrationField> {
    return await new TransmedValidateRegistrationFieldApi().put(
      `${id}`,
      new TransmedRegistrationFieldValidationInput(quantity, answer, false)
    );
  }
}
class TransmedRegistrationFieldServiceDeleter extends ServiceDeleter {}

export default class TransmedRegistrationFieldService extends Service {
  public get read(): TransmedRegistrationFieldServiceReader {
    return new TransmedRegistrationFieldServiceReader();
  }
  public get create(): TransmedRegistrationFieldServiceCreator {
    return new TransmedRegistrationFieldServiceCreator();
  }
  public get update(): TransmedRegistrationFieldServiceUpdater {
    return new TransmedRegistrationFieldServiceUpdater();
  }
  public get delete(): TransmedRegistrationFieldServiceDeleter {
    return new TransmedRegistrationFieldServiceDeleter();
  }
}
